module.exports = __webpack_public_path__ + "img/map-b.22b6878c.png";